export const Json = [
    {
        name: 'Dashboard',
        type: 'single',
        icon: 'si-cursor',
        routerLink: '#/',
        badge: '5'
    },
    {
        name: 'Base',
        type: 'over-text'
    },
    {
        name: 'Blocks',
        routerLink: '',
        icon: 'si-grid',
        type: 'menu',
        children: [
            {
                name: 'Styles',
                routerLink: ''
            },
            {
                name: 'Options',
                routerLink: ''
            },
            {
                name: 'Forms',
                routerLink: ''
            },
            {
                name: 'Themed',
                routerLink: ''
            },
            {
                name: 'API',
                routerLink: ''
            }
        ]
    },
    {
        name: 'Widgets',
        routerLink: '',
        icon: 'si-puzzle',
        type: 'menu',
        children: [
            {
                name: 'Tiles',
                routerLink: ''
            },
            {
                name: 'Statics',
                routerLink: ''
            },
            {
                name: 'Media',
                routerLink: ''
            },
            {
                name: 'Users',
                routerLink: ''
            }
        ]
    },
    {
        name: 'Layout',
        routerLink: '',
        icon: 'si-star',
        type: 'menu',
        children: [
            {
                name: 'Page',
                routerLink: null,
                children: [
                    {
                        name: 'Page',
                        routerLink: ''
                    },
                    {
                        name: 'Flipped',
                        routerLink: ''
                    },
                    {
                        name: 'Native Scrolling',
                        routerLink: ''
                    }
                ]
            },
            {
                name: 'Main Content',
                routerLink: null,
                children: [
                    {
                        name: 'Full Width',
                        routerLink: null
                    },
                    {
                        name: 'Narrow',
                        routerLink: null
                    },
                    {
                        name: 'Boxed',
                        routerLink: null
                    },
                ]
            },
            {
                name: 'Side Content',
                routerLink: null,
                children: [
                    {
                        name: 'Left',
                        routerLink: ''
                    },
                    {
                        name: 'Right',
                        routerLink: ''
                    }
                ]
            }
        ]
    },
    {
        name: 'Interface',
        type: 'over-text'
    },
    {
        name: 'Elements',
        routerLink: '',
        icon: 'si-chemistry',
        type: 'menu',
        children: [
            {
                name: 'Styles',
                routerLink: ''
            },
            {
                name: 'Options',
                routerLink: ''
            },
            {
                name: 'Forms',
                routerLink: ''
            },
            {
                name: 'Themed',
                routerLink: ''
            },
            {
                name: 'API',
                routerLink: ''
            }
        ]
    },
    {
        name: 'Tables',
        routerLink: '',
        icon: 'si-puzzle',
        type: 'menu',
        children: [
            {
                name: 'Tiles',
                routerLink: ''
            },
            {
                name: 'Statics',
                routerLink: ''
            },
            {
                name: 'Media',
                routerLink: ''
            },
            {
                name: 'Users',
                routerLink: ''
            }
        ]
    },
    {
        name: 'Forms',
        routerLink: '',
        icon: 'si-star',
        type: 'menu',
        children: [
            {
                name: 'Page',
                routerLink: null,
                children: [
                    {
                        name: 'Page',
                        routerLink: ''
                    },
                    {
                        name: 'Flipped',
                        routerLink: ''
                    },
                    {
                        name: 'Native Scrolling',
                        routerLink: ''
                    }
                ]
            },
            {
                name: 'Main Content',
                routerLink: null,
                children: [
                    {
                        name: 'Full Width',
                        routerLink: null
                    },
                    {
                        name: 'Narrow',
                        routerLink: null
                    },
                    {
                        name: 'Boxed',
                        routerLink: null
                    },
                ]
            },
            {
                name: 'Side Content',
                routerLink: null,
                children: [
                    {
                        name: 'Left',
                        routerLink: ''
                    },
                    {
                        name: 'Right',
                        routerLink: ''
                    }
                ]
            }
        ]
    }
];

export const UserMenu = [
    {
        name: 'Configurações',
        routerLink: '',
        icon: 'si-settings',
        children: [
            {
                name: 'Meus dados',
                icon: 'si-user',
                routerLink: '#/profile'
            },
            {
                name: 'Pagamentos e Recebimentos',
                icon: 'si-wallet',
                routerLink: '#/payments'
            },
            {
                name: 'Termos & Políticas',
                icon: 'si-briefcase',
                routerLink: '#/terms'
            },
        ]
    },
    {
        name: 'Gonhe dinheiro com o Bolt',
        routerLink: '',
        icon: 'si-badge',
        children: [
            {
                name: 'Anunciar meu barco',
                icon: 'si-anchor',
                routerLink: '#/boats'
            },
        ]
    },
    {
        name: 'Atendimento',
        routerLink: '',
        icon: 'si-support',
        children: [
            {
                name: 'Central de Ajuda',
                icon: 'si-question',
                routerLink: '#/help'
            },
            {
                name: 'Reportar um problema',
                icon: 'si-earphones-alt',
                routerLink: '#/report'
            },
        ]
    },
]